var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"is-full-page":true,"height":150,"width":150,"color":'#FFFF00',"background-color":'#000000',"opacity":0.5},on:{"update:active":function($event){_vm.isLoading=$event}}})],1):_vm._e(),(!_vm.isLoading)?_c('div',[_c('app-gridview',{attrs:{"parentData":{
      tabHeaders: this.dataHeader,
      tabItems: this.dataItems,
      pageTitle: this.pageTitle,
      search: this.search,
    }},on:{"EditItem":function($event){return _vm.editItemHandler($event)},"DeleteItem":function($event){return _vm.deleteItemHandler($event)},"NewPressed":_vm.newRecordHandler}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }